import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type { ClientAppServicesResponseData } from '@/types';

import { HttpClient } from '@/network/HttpClient';

export const clientAppServiceKeys = {
  all: () => ['clientAppServices'] as const,
  list: (props: { url: string }) =>
    [...clientAppServiceKeys.all(), 'list', props.url] as const,
};

export const clientAppServiceQueries = {
  list: (props: { url: string }) =>
    queryOptions({
      queryKey: clientAppServiceKeys.list(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<ClientAppServicesResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
